import React, {useState, useEffect} from 'react'
import emailjs from '@emailjs/browser';
import { Modal, Form, Button } from 'react-bootstrap';
import { emailJSInit } from '../helpers/variables';


export default function ContactForm() {

    useEffect(() => emailjs.init(emailJSInit), [])
    const [modalIsVisible, setModalIsVisible] = useState(false)

    function handleSubmit (event) {
        event.preventDefault();
        const formData = {name: event.target[1].value, email: event.target[2].value, message: event.target[3].value}
        emailjs.send('service_03oqynp', 'template_21lpl62', formData)
        .then(
            (response) => {console.log('SUCCESS!', response.status, response.text);},
            (error) => {console.log('FAILED...', error);}
        )
        .then(
            setModalIsVisible(false)
        )
    };

    function handleShow(){
        setModalIsVisible(true)
    }

    function handleClose(){
        setModalIsVisible(false)
    }

    return(
        <div className="contact-content">
            <section>
                <h2>Contact</h2>
                <p>If you have a general question, a bulk order request, or would like to consult with me about partnering with your business, please send me a note.</p>
                <button className='primary-button' onClick={handleShow}>Contact</button>
            </section>
            <Modal
                show={modalIsVisible}
                onHide={handleClose}
            >
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>General Question</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter name" />
                            <Form.Label>Email address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Question or message</Form.Label>
                            <Form.Control as="textarea" rows={3} />
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='secondary' onClick={handleClose}>Close</Button>
                        <button className='primary-button' type="submit">Submit</button>
                    </Modal.Footer>
                </Form>
            </Modal>

        </div>
    )
}